































import { Component, Prop, Vue, Model, Watch } from "vue-property-decorator";
import { MessageConfig } from "@/types";
@Component
export default class IMessage extends Vue {
  @Model("model") value!: boolean;
  @Watch("value")
  watchValue(val: boolean) {
    this.onValueChange(val);
  }

  @Prop({
    type: Object,
    default: false,
    required: true
  })
  config!: MessageConfig;

  private time = 0;
  private duration = 3;
  public inv = 0;
  private isShow = false;
  private showButtons = false;
  private percent = 0;

  private onValueChange(value: boolean) {
    if (value) {
      this.show();
    } else {
      this.close();
    }
  }

  private init() {
    this.time = 1;
    this.showButtons = this.config.onOk !== undefined;
    this.duration = this.config.duration || 3;
    this.percent = (1 / this.duration) * 100;
    clearInterval(this.inv);
  }

  private destory() {
    this.time = 0;
    this.percent = 0;
    clearInterval(this.inv);
    this.showButtons = false;
  }

  private show() {
    this.isShow = true;
    this.init();
    this.inv = setInterval(() => {
      this.time += 1;
      if (this.time > this.duration) {
        clearInterval(this.inv);
        this.config.onOk && this.config.onOk();
        this.close();
      }
    }, 1000);

    this.$emit("model", true);
  }

  private close() {
    this.isShow = false;
    this.destory();
    this.$emit("model", false);
  }

  private onOk() {
    this.close();
    this.config.onOk && this.config.onOk();
  }

  private onCancel() {
    this.close();
    this.config.onCancel && this.config.onCancel();
  }
}
